import { render, staticRenderFns } from "./CulinaryPanelmobile.vue?vue&type=template&id=15f5247e&scoped=true&"
import script from "./CulinaryPanelmobile.vue?vue&type=script&lang=js&"
export * from "./CulinaryPanelmobile.vue?vue&type=script&lang=js&"
import style0 from "./CulinaryPanelmobile.vue?vue&type=style&index=0&id=15f5247e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f5247e",
  null
  
)

export default component.exports